import { render, staticRenderFns } from "./ScheduledReportsDashboard.vue?vue&type=template&id=b6c20e2a&"
import script from "./ScheduledReportsDashboard.vue?vue&type=script&lang=ts&"
export * from "./ScheduledReportsDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduledReportsDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports